import OrderItem from './OrderItem';
import ContactInfo from './ContactInfo';
import Payment from './Payment';
import Shipment from './Shipment';
import Discount from './Discount';
import { OrderStatus } from './OrderStatus';
import { MailType } from './MailType';

export default class Order {
    public orderId: string;
    public userId: string;
    public totalAmount: number;
    public orderItems: OrderItem[];
    public contactInfo: ContactInfo;
    public payment: Payment;
    public shipment: Shipment;
    public discount: Discount;
    public creationDateTime: Date;
    public orderDateTime: Date;
    public status: OrderStatus;
    public mailsDelivered: Map<MailType, number>;
}
